import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__